export const appContent = {
  title: 'забота о доме<br> от сервисной<br> компании <span>«Территория<br> комфорта»</span>',
  text: 'вам больше не нужно искать мастеров<br> <span>или тратить время на решение<br> коммунальных вопросов</span>',
  buttonLabel: 'узнать подробнее',
  buttonHref: 'https://terrkomf.ru/',
};